export const MUNICIPIOS = [
  'Rio Branco','Cruzeiro do Sul','Sena Madureira','Tarauacá','Feijó',
  'Brasileia','Epitaciolândia','Xapuri','Plácido de Castro','Senador Guiomard',
  'Acrelândia','Bujari','Porto Acre','Capixaba','Rodrigues Alves',
  'Mâncio Lima','Marechal Thaumaturgo','Porto Walter','Jordão',
  'Santa Rosa do Purus','Manoel Urbano','Assis Brasil',
];

export const AREAS = [
  'Administração','Agropecuária','Arquitetura e Urbanismo','Artes e Design',
  'Atendimento ao Cliente','Comércio e Vendas','Comunicação e Marketing',
  'Construção Civil','Contabilidade e Finanças','Direito e Jurídico',
  'Educação e Ensino','Engenharia','Gastronomia e Hotelaria',
  'Logística e Transporte','Meio Ambiente','Medicina e Saúde',
  'Recursos Humanos','Segurança e Vigilância','Serviços Gerais',
  'Tecnologia da Informação','Turismo',
];
